module.exports = __webpack_public_path__ + "img/5-emerald.b110e7ae.png";